module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'nav-open': _vm.$sidebar.showSidebar
    }
  }, [_c('simplert'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('vue-progress-bar'), _vm._v(" "), _c('popup-spinner', {
    attrs: {
      "size": "75px",
      "padding": "15px",
      "title": _vm.$t('please_wait_spinner')
    }
  }), _vm._v(" "), _c('side-bar', {
    attrs: {
      "type": "navbar",
      "sidebar-links": _vm.$sidebar.sidebarLinks
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', {
    staticClass: "btn-rotate",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "ti-view-grid"
  }), _vm._v(" "), _c('p', [_vm._v("\n            Project: "), _c('span', [_vm._v(_vm._s(_vm.activeProjectName))])])])]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "title": _vm.activeUserName,
      "icon": "ti-user"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/changeinfo"
    }
  }, [_c('i', {
    staticClass: "ti-pencil"
  }), _vm._v(" Edit account")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/changepassword"
    }
  }, [_c('i', {
    staticClass: "ti-key"
  }), _vm._v(" Change password")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "ti-car"
  }), _vm._v(" Log out")])])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c95520","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 380
// module chunks = 1